import { type FC, useEffect, useRef, useState } from 'react';
import ArrowIcon from '@public/assets/common/icons/arrowRightOutlined.svg';
import type { CouponActingOddProps } from './CouponActingOdd.types';
import styles from './CouponActingOdd.module.scss';
const animationTimeout = 1000;
const CouponActingOdd: FC<CouponActingOddProps> = ({
  odd,
  className
}) => {
  const timer = useRef<NodeJS.Timeout | null>(null);
  const [prevOdd, setPrevOdd] = useState(odd);
  const hasPrevOdd = !!prevOdd;
  const isOddChanged = hasPrevOdd && prevOdd !== odd;
  useEffect(() => {
    timer.current = setTimeout(() => setPrevOdd(odd), animationTimeout);
    return () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    };
  }, [odd]);
  return <div className={cn(styles.root, className)} data-sentry-component="CouponActingOdd" data-sentry-source-file="CouponActingOdd.tsx">
      <span className={cn(styles.newValue, {
      [styles.visible]: isOddChanged,
      [styles.increase]: Number(odd) > Number(prevOdd),
      [styles.decrease]: Number(odd) < Number(prevOdd)
    })}>
        {odd}
      </span>
      <ArrowIcon className={cn(styles.arrow, {
      [styles.visible]: isOddChanged
    })} data-sentry-element="ArrowIcon" data-sentry-source-file="CouponActingOdd.tsx" />
      <span className={cn({
      [styles.prev]: isOddChanged
    })}>{isOddChanged ? prevOdd : odd}</span>
    </div>;
};
export { CouponActingOdd };